module.exports = __webpack_public_path__ + "static/media/illus-start-rect.e25a1c3e.png";